import React, { useContext } from "react";
import { themeContext } from "../../lib";

interface IPlusFolderProps {
    sizeX?: number;
    sizeY?: number;
}

export const PlusFolder: React.FC<IPlusFolderProps> = ({ sizeX = 17, sizeY = 16 }) => {
    const [theme] = useContext(themeContext);

    return (
        <svg width={sizeX} height={sizeY} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M8.50016 6.66667V10.6667M6.50016 8.66667H10.5002M13.8335 13.3333C14.1871 13.3333 14.5263 13.1929 14.7763 12.9428C15.0264 12.6928 15.1668 12.3536 15.1668 12V5.33333C15.1668 4.97971 15.0264 4.64057 14.7763 4.39052C14.5263 4.14048 14.1871 4 13.8335 4H8.56683C8.34384 4.00219 8.12386 3.94841 7.92703 3.84359C7.7302 3.73877 7.5628 3.58625 7.44016 3.4L6.90016 2.6C6.77876 2.41565 6.61348 2.26432 6.41916 2.1596C6.22484 2.05488 6.00757 2.00004 5.78683 2H3.16683C2.81321 2 2.47407 2.14048 2.22402 2.39052C1.97397 2.64057 1.8335 2.97971 1.8335 3.33333V12C1.8335 12.3536 1.97397 12.6928 2.22402 12.9428C2.47407 13.1929 2.81321 13.3333 3.16683 13.3333H13.8335Z"
                stroke={theme === "dark" ? "white" : "black"} strokeOpacity="0.4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
}
